import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.ACHFundScheduleResponse | undefined,
  (requestParams?: vp.ACHFundScheduleRequest) => void,
  () => void,
  (requestParams: vp.ACHFundScheduleRequest) => Promise<vp.ACHFundScheduleResponse>,
];

function usePostACHFundSchedule({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.ACHFundScheduleRequest>();
  const [response, setResponse] = useState<vp.ACHFundScheduleResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.ACHFundScheduleRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');

      const res = await api.postACHFundSchedule(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams?: vp.ACHFundScheduleRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
    (requestParams: vp.ACHFundScheduleRequest) => api.postACHFundSchedule(requestParams, source),
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(usePostACHFundSchedule);
